const EnKeyAuthority = {
  "ROLE_SUPER_ADMIN": "系统管理员",
  "ROLE_APP_ADMIN": "应用管理员",
  "ROLE_USER": "普通用户"
}

export function ParseAuthorityEn2Ch(enAuthority) {
  let result = EnKeyAuthority[enAuthority]
  if (result == null) {
    throw new Error(`无法将${enAuthority}转化为中文`)
  }
  return result
}

export const AppAuthority = {
  creator: 3,
  admin: 2,
  user: 1
}

export let appInfoRules = {
  appName: [
    {required: true, message: "请输入应用名称", trigger: 'blur'},
    {max: 100, message: "应用名不能超过100个字符", trigger: 'blur'},
  ],
  appDescribe: [
    {required: true, message: "请输入应用介绍", trigger: 'blur'},
    {max: 100, message: "应用介绍不能超过100个字", trigger: 'blur'},
  ]
}

function validateVersion(rule, value, callback) {
  let versionPattern = /^(\d+\.){2,3}\d+$/;
  if (versionPattern.test(value) === false) {
    callback(new Error("版本信息只能是由数字与小数点组成的，示例：12.12.12.12"))
  }
  callback()
}

export let releaseRules = {
  version: [
    {required: true, message: "版本信息不能为空", trigger: 'blur'},
    {validator: validateVersion, trigger: 'blur'}
  ],
  log: [
    {required: true, message: "请输入日志信息", trigger: 'blur'},
    {max: 200, message: "日志信息不能超过200个字符", trigger: 'blur'},
  ]
}
